const DEVICE_ID_KEY = "device_id";
const LEGACY_DEVICE_ID_KEY = "adminDeviceId";

/** Persistent browser device id — survives logins; cleared only if user clears storage. */
export function getOrCreateDeviceId() {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = localStorage.getItem(LEGACY_DEVICE_ID_KEY);
    if (deviceId) {
      localStorage.setItem(DEVICE_ID_KEY, deviceId);
      localStorage.removeItem(LEGACY_DEVICE_ID_KEY);
    }
  }

  if (!deviceId) {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      deviceId = crypto.randomUUID();
    } else {
      deviceId = `web_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
    }
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
}

function parseBrowserFromUa(ua) {
  if (/Edg\//i.test(ua)) {
    return { browser_name: "Edge", browser_version: ua.match(/Edg\/([\d.]+)/i)?.[1] || "" };
  }
  if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) {
    return { browser_name: "Chrome", browser_version: ua.match(/Chrome\/([\d.]+)/i)?.[1] || "" };
  }
  if (/Firefox\//i.test(ua)) {
    return { browser_name: "Firefox", browser_version: ua.match(/Firefox\/([\d.]+)/i)?.[1] || "" };
  }
  if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) {
    return { browser_name: "Safari", browser_version: ua.match(/Version\/([\d.]+)/i)?.[1] || "" };
  }
  return { browser_name: "Unknown", browser_version: "" };
}

export function getDeviceModel() {
  const ua = navigator.userAgent || "";
  if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (/\bAndroid\b/i.test(ua) && !/Mobile/i.test(ua))) {
    return "Tablet";
  }
  if (/Mobi|Android|iPhone|iPod|Windows Phone/i.test(ua)) {
    return "Mobile";
  }
  return "Laptop";
}

export function getDeviceRegistrationPayload(deviceToken = "") {
  const { browser_name, browser_version } = parseBrowserFromUa(navigator.userAgent || "");
  const token =
    deviceToken ||
    localStorage.getItem("fcmToken") ||
    "";

  return {
    platform: "web",
    browser_name,
    browser_version,
    device_model: getDeviceModel(),
    device_id: getOrCreateDeviceId(),
    device_token: token,
  };
}

export function isAdminLoggedIn() {
  return (
    localStorage.getItem("isLoggedIn") === "true" &&
    Boolean(localStorage.getItem("accessToken") || localStorage.getItem("authAccessToken"))
  );
}
